// 首页看板相关接口
import { get, post } from '@/utils/request'
import { safeRequest, errDefaultMsg } from '@/utils/tool'
import { Message } from 'element-ui'
import debounce from 'lodash/debounce'

// 售后首页数据 + 响铃 （杜勇清）
export const getHomePageData = () => get('/popOrder/getHomePageData')

// 查询首页商家信息 （刘建华）
export const getCompanyInfo = safeRequest(() => post(`/homePage/getCompanyInfo`))

// 统计公司下未上架的促销
export const statisticalNotEnable = safeRequest(companyId => get(`/promotion/statisticalNotEnable/${companyId}`))

// 统计公司下即将到期促销（两天内）
export const statisticalAboutToExpire = safeRequest(companyId => get(`/promotion/statisticalAboutToExpire/${companyId}`))

// 统计公司下即有效的优惠活动
export const statisticalValidCoupon = safeRequest(companyId => get(`/voucher/statisticalValidCoupon/${companyId}`))

// 售后首页数据
export const afterSales = safeRequest(() => get(`/popOrder/getHomePageData`))

// 账号下返佣金额信息
export const companyAcctDetailInfo = safeRequest(() => post(`/accountDetail/companyAcctDetailInfo`))

// 首页看版数据评价统计  （郭广飞）
export const countCommentNumForHomePage = safeRequest(companyId => get(`/comment/1.0.0/countCommentNumForHomePage`, { companyId }))

// 获取最下边的应用市场 （宋人龙）
export const getCompanyOrderStatus = safeRequest(params => get('/serviceOrder/getCompanyOrderStatus', params))
// 以下为bi接口，（王继云）
/* http://192.168.86.25:8080/doc.html#/%E5%8F%AE%E5%BD%93%E9%80%9AAPI/%E5%8F%AE%E5%BD%93%E9%80%9ABI%E6%8E%A5%E5%8F%A3/initRealTimeUsingPOST */
// 实时订单统计初始接口
export const ddtbiInitRealTime = safeRequest(() => post(`/ddtbi/initRealTime`, {}, { API: 'BI' }))
// 实时订单线图
export const ddtbiRealTimeLine = safeRequest(params => post(`/ddtbi/realTimeLine`, params, { API: 'BI' }))
// 昨日关键指标
export const ddtbiOfflineLastDataIndi = safeRequest(() => post(`/ddtbi/offline/lastDataIndi`, {}, { API: 'BI' }))
// 上周关键指标
export const ddtbiOfflineQueryLastWeek = safeRequest(() => post(`/ddtbi/offline/queryLastWeek`, {}, { API: 'BI' }))
// 销售榜单
export const ddtbiOfflineLastSalesTopn = safeRequest(() => post(`/ddtbi/offline/lastSalesTopn`, {}, { API: 'BI' }))
// 门店销售概况
export const ddtbiOfflineQueryShopBI = safeRequest(() => post(`/ddtbi/offline/queryShopBI`, {}, { API: 'BI' }))

const debounceMessage = debounce(msg => {
  Message.error(msg || errDefaultMsg)
}, 1000)

export const handleBiRes = (res, code) => {
  res = res || {}
  if (res.code === 0 || res.code === 200) {
    return res
  }
  // 账号未授权有效门店或者分公司，一般来说是首次进来的情况，此时为了体验，这种错误只提示一次
  if (res.code === 1202 || res.code === code) {
    debounceMessage(res.msg)
    return
  }
  Message.error(res.msg || errDefaultMsg)
}
